var _path, _path2, _path3, _g, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _path9, _path0, _g5, _path1, _path10, _g6, _path11, _path12, _path13, _g7, _path14, _g8, _path15, _path16, _g9, _path17, _path18, _g0, _path19, _path20, _g1, _g10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPikkoThankBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 286,
    viewBox: "0 0 160 286",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13942_54767)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M79.6583 204.566C112.076 204.566 138.356 200.186 138.356 194.783C138.356 189.38 112.076 185 79.6583 185C47.2407 185 20.9609 189.38 20.9609 194.783C20.9609 200.186 47.2407 204.566 79.6583 204.566Z",
    fill: "black",
    fillOpacity: 0.43
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2941 47.1385C29.2941 47.1385 70.923 44.3243 71.2064 88.4857C26.4467 88.2055 29.2941 47.1385 29.2941 47.1385Z",
    fill: "#71B261"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13942_54767",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 43,
    width: 49,
    height: 49
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7344 43.582H74.5606V91.2707H26.7344V43.582Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13942_54767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.647 90.9067L71.199 90.894C56.7622 90.7985 45.5337 86.6026 37.8225 78.402C25.75 65.5725 26.8387 47.745 26.8902 46.9937L27.0319 44.9244L29.1385 44.778C29.1385 44.778 29.7312 44.7334 30.7748 44.7334C37.8869 44.7334 73.3635 46.8472 73.6341 88.4873L73.647 90.9067Z",
    fill: "url(#paint0_linear_13942_54767)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13942_54767",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 0,
    width: 35,
    height: 67
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3594 0.185547H95.9921V66.3958H61.3594V0.185547Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_13942_54767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.8869 65.5597L77.1669 63.8406C67.0206 53.7043 62.0923 42.8996 62.5175 31.7255C63.1811 14.2291 76.7224 2.3865 77.3021 1.89624L78.8869 0.527344L80.4781 1.89624C81.0579 2.3865 94.5992 14.2291 95.2627 31.7255C95.6879 42.8996 90.7597 53.7043 80.6134 63.8406L78.8869 65.5597Z",
    fill: "url(#paint1_linear_13942_54767)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129.631 47.1385C129.631 47.1385 88.0086 44.3243 87.7188 88.4857C132.485 88.2055 129.631 47.1385 129.631 47.1385Z",
    fill: "#71B261"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_13942_54767",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 84,
    y: 43,
    width: 49,
    height: 49
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4375 43.582H132.264V91.2707H84.4375V43.582Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_13942_54767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.2891 90.9067L85.3084 88.4873C85.579 46.8472 121.056 44.7334 128.161 44.7334C129.211 44.7334 129.804 44.778 129.804 44.778L131.904 44.9244L132.052 46.9937C132.104 47.745 133.193 65.5662 121.12 78.402C113.415 86.6026 102.18 90.7985 87.7371 90.894L85.2891 90.9067Z",
    fill: "url(#paint2_linear_13942_54767)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_13942_54767",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 70,
    width: 113,
    height: 129
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4141 70.6895H135.558V198.245H23.4141V70.6895Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_13942_54767)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_13942_54767",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 70,
    width: 111,
    height: 129
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6038 198.254V70.7999C99.2238 70.7744 98.8501 70.7744 98.47 70.7744H60.5389V198.254H99.6038ZM50.8178 198.254H60.5389V70.7999H60.3263C44.6076 70.7999 30.8086 83.4765 29.6748 98.9547L24.3601 170.131C23.194 185.577 35.1055 198.254 50.8178 198.254ZM107.972 198.254C123.691 198.254 135.596 185.577 134.436 170.099L129.115 98.9292C127.981 83.8267 114.807 71.392 99.5781 70.7999V198.254H107.972Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_13942_54767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.519 198.254H24.3594V70.6982H134.519V198.254Z",
    fill: "url(#paint3_linear_13942_54767)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_13942_54767",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 67,
    width: 52,
    height: 51
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7969 67.4678H72.0066V117.092H21.7969V67.4678Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_13942_54767)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_13942_54767",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 67,
    width: 52,
    height: 51
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9018 67.4795C33.0383 67.4795 21.7969 78.5835 21.7969 92.2916C21.7969 105.993 33.0383 117.104 46.9018 117.104C60.7652 117.104 72.0066 105.993 72.0066 92.2916C72.0066 78.5835 60.7652 67.4795 46.9018 67.4795Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_13942_54767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7969 67.4795H72.0066V117.104H21.7969V67.4795Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_13942_54767",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 76,
    width: 32,
    height: 32
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2734 76.7744H62.5821V107.724H31.2734V76.7744Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_13942_54767)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_13942_54767",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 76,
    width: 32,
    height: 32
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9277 76.7744C38.2824 76.7744 31.2734 83.7017 31.2734 92.2525C31.2734 100.797 38.2824 107.724 46.9277 107.724C55.573 107.724 62.5821 100.797 62.5821 92.2525C62.5821 83.7017 55.573 76.7744 46.9277 76.7744Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_13942_54767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2734 76.7744H62.5821V107.724H31.2734V76.7744Z",
    fill: "#3D1F1E"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7141 92.2023C46.7141 88.4782 49.5233 85.7935 53.2094 85.7935C49.6946 85.7935 46.7171 82.9338 46.7171 79.3819C46.7171 82.9 43.9383 85.7935 40.2188 85.7935C43.9383 85.7935 46.7141 88.6134 46.7141 92.2023Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7141 79.3789L46.7171 79.3819M46.7171 79.3819C46.7171 82.9338 49.6946 85.7935 53.2094 85.7935C49.5233 85.7935 46.7141 88.4782 46.7141 92.2023C46.7141 88.6134 43.9383 85.7935 40.2188 85.7935C43.9383 85.7935 46.7171 82.9 46.7171 79.3819Z",
    stroke: "white",
    strokeWidth: 4.82286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_13942_54767",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 118,
    width: 37,
    height: 41
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8516 118.162H97.3733V158.007H61.8516V118.162Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_13942_54767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.6087 168.442C78.4427 168.442 77.2896 168.283 76.1493 167.958C75.0026 167.64 73.8946 167.162 72.8188 166.532C71.7429 165.895 70.7186 165.125 69.7523 164.208C68.7796 163.291 67.8841 162.247 67.0595 161.082C66.2349 159.91 65.5005 158.643 64.8563 157.268C64.2057 155.899 63.6581 154.448 63.2136 152.919C62.7691 151.398 62.4341 149.825 62.2022 148.208C61.9767 146.584 61.8672 144.954 61.8672 143.299C61.8672 141.65 61.9767 140.014 62.2022 138.396C62.4341 136.779 62.7691 135.207 63.2136 133.678C63.6581 132.157 64.2057 130.705 64.8563 129.336C65.5005 127.961 66.2349 126.694 67.0595 125.522C67.8841 124.357 68.7796 123.313 69.7523 122.396C70.7186 121.479 71.7429 120.709 72.8188 120.072C73.8946 119.442 75.0026 118.964 76.1493 118.646C77.2896 118.321 78.4427 118.162 79.6087 118.162C80.7748 118.162 81.9279 118.321 83.0681 118.646C84.2148 118.964 85.3229 119.442 86.3987 120.072C87.4745 120.709 88.4988 121.479 89.4652 122.396C90.4379 123.313 91.3334 124.357 92.158 125.522C92.9825 126.694 93.7169 127.961 94.3612 129.336C95.0118 130.705 95.5594 132.157 96.0039 133.678C96.4484 135.207 96.7834 136.779 97.0153 138.396C97.2408 140.014 97.3503 141.65 97.3503 143.299C97.3503 144.954 97.2408 146.584 97.0153 148.208C96.7834 149.825 96.4484 151.398 96.0039 152.919C95.5594 154.448 95.0118 155.899 94.3612 157.268C93.7169 158.643 92.9825 159.91 92.158 161.082C91.3334 162.247 90.4379 163.291 89.4652 164.208C88.4988 165.125 87.4745 165.895 86.3987 166.532C85.3229 167.162 84.2148 167.64 83.0681 167.958C81.9279 168.283 80.7748 168.442 79.6087 168.442Z",
    fill: "#3D1F1E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_13942_54767",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 144,
    width: 32,
    height: 23
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8828 144.674H94.5988V166.493H63.8828V144.674Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_13942_54767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.5988 155.58C94.5988 156.294 94.4957 157 94.3024 157.707C94.1027 158.407 93.8128 159.089 93.4263 159.751C93.0398 160.413 92.5695 161.037 92.009 161.635C91.4486 162.228 90.8108 162.782 90.0957 163.285C89.3871 163.794 88.6076 164.246 87.7701 164.641C86.9327 165.042 86.0501 165.373 85.116 165.647C84.1819 165.92 83.222 166.131 82.2364 166.271C81.2443 166.411 80.2458 166.481 79.2408 166.481C78.2294 166.481 77.2308 166.411 76.2452 166.271C75.2531 166.131 74.2933 165.92 73.3591 165.647C72.4315 165.373 71.5425 165.042 70.705 164.641C69.8675 164.246 69.088 163.794 68.3794 163.285C67.6643 162.782 67.0266 162.228 66.4661 161.635C65.9056 161.037 65.4354 160.413 65.0488 159.751C64.6623 159.089 64.3724 158.407 64.1727 157.707C63.9794 157 63.8828 156.294 63.8828 155.58C63.8828 154.861 63.9794 154.154 64.1727 153.448C64.3724 152.747 64.6623 152.066 65.0488 151.404C65.4354 150.742 65.9056 150.118 66.4661 149.519C67.0266 148.927 67.6643 148.373 68.3794 147.87C69.088 147.361 69.8675 146.909 70.705 146.514C71.5425 146.113 72.4315 145.782 73.3591 145.508C74.2933 145.234 75.2531 145.024 76.2452 144.884C77.2308 144.744 78.2294 144.674 79.2408 144.674C80.2458 144.674 81.2443 144.744 82.2364 144.884C83.222 145.024 84.1819 145.234 85.116 145.508C86.0501 145.782 86.9327 146.113 87.7701 146.514C88.6076 146.909 89.3871 147.361 90.0957 147.87C90.8108 148.373 91.4486 148.927 92.009 149.519C92.5695 150.118 93.0398 150.742 93.4263 151.404C93.8128 152.066 94.1027 152.747 94.3024 153.448C94.4957 154.154 94.5988 154.861 94.5988 155.58Z",
    fill: "#FA5B5B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_13942_54767",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 67,
    width: 52,
    height: 51
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8281 67.498H137.038V117.122H86.8281V67.498Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_13942_54767)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_13942_54767",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 67,
    width: 52,
    height: 51
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M111.933 67.5098C98.0632 67.5098 86.8281 78.6138 86.8281 92.3219C86.8281 106.024 98.0632 117.134 111.933 117.134C125.796 117.134 137.038 106.024 137.038 92.3219C137.038 78.6138 125.796 67.5098 111.933 67.5098Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_13942_54767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.8281 67.5098H137.038V117.134H86.8281V67.5098Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_13942_54767",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 76,
    width: 32,
    height: 32
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M96.25 76.8047H127.565V107.755H96.25V76.8047Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_13942_54767)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_13942_54767",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 76,
    width: 32,
    height: 32
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M111.911 76.8047C103.259 76.8047 96.25 83.732 96.25 92.2828C96.25 100.827 103.259 107.755 111.911 107.755C120.556 107.755 127.565 100.827 127.565 92.2828C127.565 83.732 120.556 76.8047 111.911 76.8047Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_13942_54767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.25 76.8047H127.565V107.755H96.25V76.8047Z",
    fill: "#3D1F1E"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M111.917 92.2023C111.917 88.4782 114.726 85.7935 118.413 85.7935C114.898 85.7935 111.92 82.9338 111.92 79.3819C111.92 82.9 109.141 85.7935 105.422 85.7935C109.141 85.7935 111.917 88.6134 111.917 92.2023Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M111.917 79.3789L111.92 79.3819M111.92 79.3819C111.92 82.9338 114.898 85.7935 118.413 85.7935C114.726 85.7935 111.917 88.4782 111.917 92.2023C111.917 88.6134 109.141 85.7935 105.422 85.7935C109.141 85.7935 111.92 82.9 111.92 79.3819Z",
    stroke: "white",
    strokeWidth: 4.82286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13942_54767)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.9688,
    y: 207,
    width: 17.2109,
    height: 15.0086,
    rx: 7.50429,
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_13942_54767)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.375,
    y: 230.009,
    width: 26.4141,
    height: 22.457,
    rx: 11.2285,
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13942_54767",
    x: 26.9688,
    y: 167,
    width: 105.211,
    height: 103.009,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.46 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13942_54767"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13942_54767",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_13942_54767",
    x: 28.475,
    y: 196.109,
    width: 102.214,
    height: 98.257,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13942_54767"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13942_54767",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13942_54767",
    x1: 50.2454,
    y1: 44.7334,
    x2: 50.2454,
    y2: 90.9067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13942_54767",
    x1: 78.8901,
    y1: 0.527344,
    x2: 78.8901,
    y2: 65.5597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13942_54767",
    x1: 108.694,
    y1: 44.7334,
    x2: 108.694,
    y2: 90.9067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13942_54767",
    x1: 79.4394,
    y1: 70.6982,
    x2: 79.4394,
    y2: 198.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#FFDE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F19F10"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13942_54767"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.078125,
    width: 159,
    height: 286,
    rx: 79.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPikkoThankBox);
export default __webpack_public_path__ + "static/media/pikkoThankBox.8580410e3fb1c2700dc769a949ec3f6d.svg";
export { ForwardRef as ReactComponent };